<template>
  <div class="header whole-bgt">
    <div class="head-time flex-center">
      <p>{{ `${newTime} ${weather.weather} ${weather.temperature}℃` }}</p>
      <i :class="iconCondition" style=""></i>
      <!-- <p>2022-12-01 12:06:25多云 13-15℃</p> -->
      <!-- <img src="../assets/images/tq.png" alt=""> -->
    </div>
    <div class="head-tt"><span>红寺堡区农业产业数字化服务平台</span></div>
    <div class="head-r flex-center" style="margin-right: 56px">
      <div class="head-icon flex-center">
        <img src="../assets/images/user.png" alt="" />
        <p>欢迎您！</p>
      </div>
      <!-- <div class="head-return">退出登录</div> -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      myTimeDisplay: null,
      myWeatherDisplay: null,
      newTime: "", //当前时间
      weather: {}, //用于存放天气相关的数据
      iconCondition: null //icon
    };
  },
  created() {},
  mounted() {
    this.getNowTime(); //进入页面调用该方法获取当前时间
    this.getWether();
    this.myTimeDisplay = setInterval(() => {
      this.getNowTime(); //每秒更新一次时间
    }, 1000);
    this.myWeatherDisplay = setInterval(() => {
      this.getWether(); //每秒更新一次时间
    }, 600000);
  },
  beforeDestroy() {
    clearInterval(this.myTimeDisplay); //销毁之前定时器
    this.myTimeDisplay = null;
    clearInterval(this.myWeatherDisplay);
    this.myWeatherDisplay = null;
  },
  destroyed() {},
  methods: {
    async getWether() {
      const { data } = await axios.get(
        // `https://restapi.amap.com/v3/weather/weatherInfo?key=9a6e2806dad2193230b648286c4844bd&city=640303`
        `https://restapi.amap.com/v3/weather/weatherInfo?key=7952f0543749fe21298320bc5c58ccdf&city=640303`
      );
      this.weather = data.lives[0];
      this.iconCondition = this.setWeatherIcon(data.lives[0]?.weather);
    },
    // 设置icon
    setWeatherIcon(weather) {
      // 处理了基础的天气
      if (weather === "晴") {
        return "iconfont icon-lieri";
      } else if (weather.includes("云")) {
        return "iconfont icon-duoyun";
      } else if (weather.includes("风")) {
        return "iconfont icon-feng";
      } else if (weather.includes("雨")) {
        return "iconfont icon-dayu";
      } else if (weather.includes("雪")) {
        return "iconfont icon-zhongxue";
      } else if (weather.includes("雾")) {
        return "iconfont icon-wuqi";
      }
      return "iconfont icon-tianqi";
    },
    getNowTime() {
      //
      let date = new Date();
      let time =
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1) +
        "-" +
        date.getDate() +
        " " +
        date.getHours() +
        ":" +
        date.getMinutes() +
        ":" +
        date.getSeconds();
      this.newTime = time;
    }
  }
};
</script>
<style scoped>
.header {
  background-image: url(../assets/images/nei-hd.png);
  height: 107px;
  color: #ffffff;
  padding: 0 30px;
  font-size: 14px;
  position: relative;
}

.head-time {
  position: absolute;
  top: 18px;
  left: 30px;
  display: flex;
  align-items: center;
  height: 30px;
}
.head-time p {
  text-align: right;
  min-width: 223px;
}

.head-time .iconfont {
  width: 44px;
  font-size: 22px;
  margin-left: 10px;
  margin-right: 36px;
}

.head-tt {
  font-size: 47px;
  text-align: center;
  font-weight: bold;
  padding-top: 6px;
}

.head-tt span {
  background-image: -webkit-linear-gradient(bottom, #b9e4ff, #ffffff);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.head-r {
  position: absolute;
  top: 16px;
  right: 30px;
}

.head-icon img {
  width: 36px;
  height: 36px;
}

.head-icon p {
  color: #659ae7;
  margin: 0 5px 0 10px;
}

.head-return {
  color: #cce1ff;
}
</style>
